<div>
  <div class="form-sec order-search-form reportsPage">
    <div class="row">
      <div class="col-md-10">
        <h3>Substitution Order Report</h3>
      </div>
      <div class="col-md-2 text-right m-auto">
        <img src="../assets/icon/svg/manage-reports.svg" (click)="selectFilter()" />
        <a href="Javascript:void(0);" style="color: #0b3f54; padding:15px;" (click)="selectFilter()">MANAGE REPORTS</a>
      </div>
    </div>
    <div class="row margin-r0 margin-b10 margin-t15 quickSearchTopFilter">
      <div class="col-sm-7 col-md-9 col-lg-10 smallPadRgt0 margin-b10">
        <div class="row search-box-outer">
          <div class="col-md-3 col-lg-3 padding-r0 borderRight padding-l0">
            <div class="category-dropdown material-select">
              <ng-select [items]="searchTypeList"
                         name="ddlProductSearch"
                         [(ngModel)]="selectedValue"
                         (ngModelChange)="enableDisableSearch()"
                         [virtualScroll]="true"
                         [closeOnSelect]="true"
                         [selectOnTab]="true"
                         [clearable]="false"
                         bindValue="value"
                         labelForId="name"
                         [searchable]="false"
                         (change)="keepFilter()">
              </ng-select>
            </div>
          </div>
          <div class="col-md-9 col-lg-9 padding-l0 padding-r0">
            <div class="material-select reports-search-filter">

              <div #parentAccountNo *ngIf="selectedValue === 'Parent Account No'">
                <div class="search-box-outer margin-l10">
                  <div class="search-box wide100">
                    <span class="search-icon">
                      <i class="fas fa-search"></i>
                    </span>
                    <div class="select-container">
                      <input (keyup.enter)="keepFilter();" [(ngModel)]="filterList.ParentNo" (ngModelChange)="validateProductSearch()"
                             placeholder="Search..." type="text">
                    </div>
                  </div>
                </div>
              </div>

              <ng-select #AccountNo *ngIf="selectedValue === 'Account No' && isEvolveAccountRestriction == true"
                         [items]="accountNoList"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="filterList.AccountNo"
                         [virtualScroll]="true"
                         bindLabel="accountNameCityState"
                         bindValue="accountNumber"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </p>
                        <p class="phoneNo" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account #: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
              <div #txtAccountNo *ngIf="selectedValue === 'Account No' && isEvolveAccountRestriction == false">
                <div class="search-box-outer margin-l10">
                  <div class="search-box wide100">
                    <span class="search-icon">
                      <i class="fas fa-search"></i>
                    </span>
                    <div class="select-container">
                      <input (keyup.enter)="keepFilter();" [(ngModel)]="filterList.TxtAccountNo" (ngModelChange)="validateProductSearch()"
                             placeholder="Search..." type="text" pattern="^[0-9, ]+$" #accountCtrl>
                    </div>
                  </div>
                </div>
              </div>
              <div #accountName *ngIf="selectedValue === 'Account Name'">
                <div class="search-box-outer margin-l10">
                  <div class="search-box wide100">
                    <span class="search-icon">
                      <i class="fas fa-search"></i>
                    </span>
                    <div class="select-container">
                      <input (keyup.enter)="keepFilter();" [(ngModel)]="filterList.AccountName" (ngModelChange)="validateProductSearch()"
                             placeholder="Search..." type="text">
                    </div>
                  </div>
                </div>
              </div>
              <div #city *ngIf="selectedValue === 'City'">
                <div class="search-box-outer margin-l10">
                  <div class="search-box wide100">
                    <span class="search-icon">
                      <i class="fas fa-search"></i>
                    </span>
                    <div class="select-container">
                      <input (keyup.enter)="keepFilter();" [(ngModel)]="filterList.City" (ngModelChange)="validateProductSearch()"
                             placeholder="Search..." type="text" pattern="^[a-zA-Z0-9,]+$" #cityCtrl>
                    </div>
                  </div>
                </div>
              </div>
              <ng-select #State *ngIf="selectedValue === 'State/ Province'"
                         [items]="stateMasterList"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="filterList.State"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFun"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
              <div #productName *ngIf="selectedValue === 'Product Name'">
                <div class="search-box-outer margin-l10">
                  <div class="search-box wide100">
                    <span class="search-icon">
                      <i class="fas fa-search"></i>
                    </span>
                    <div class="select-container">
                      <input (keyup.enter)="keepFilter();" [(ngModel)]="filterList.Brand" (ngModelChange)="validateProductSearch()"
                             placeholder="Search..." type="text">
                    </div>
                  </div>
                </div>
              </div>

              <div class="search-box-outer" *ngIf="isEvolveAccountRestriction == false && selectedValue === 'Technology'">
                <div class="reports-search-filter">
                  <div class="search-box-outer margin-l10">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter();" placeholder="Search..." type="text" [(ngModel)]="filterList.Technology">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div #orderNo *ngIf="selectedValue === 'Order No'">
                <div class="search-box-outer margin-l10">
                  <div class="search-box wide100">
                    <span class="search-icon">
                      <i class="fas fa-search"></i>
                    </span>
                    <div class="select-container">
                      <input (keyup.enter)="keepFilter();" [(ngModel)]="filterList.OrderId" (ngModelChange)="validateProductSearch()"
                             placeholder="Search..." type="text" pattern="^[a-zA-Z0-9,]+$" #orderIdCtrl>
                    </div>
                  </div>
                </div>
              </div>

              <ng-select #MarketingBrand *ngIf="selectedValue === 'Marketing Brand'"
                         [items]="marketingMasterList"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="filterList.MarketingBrandList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFun"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
              <ng-select #ProductLine *ngIf="selectedValue === 'Product Line'"
                         [items]="productLineMasterList"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="filterList.ProductLineList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFun"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
              <ng-select #seedsize *ngIf="selectedValue === 'Seed Size'"
                         [items]="seedsizeMasterList"
                         placeholder="Search..."
                         [multiple]="true"
                         [hideSelected]="true"
                         class="custom-select-grower"
                         [(ngModel)]="filterList.SeedSizeList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFun"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
              <ng-select #PackageSize *ngIf="selectedValue === 'Package Size'"
                         [items]="packagesizeMasterList"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="filterList.PackageSizeList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFun"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
              <ng-select #Treatment *ngIf="selectedValue === 'Treatment'"
                         [items]="treatmentMasterList"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="filterList.TreatmentList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFun"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
              <div class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Substitution Date'">
                <div class="text-center deliveryDatePicker">
                  <mat-form-field>
                    <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="From" [matDatepickerFilter]="fromSubstitutionDateFilter"
                           readonly [(ngModel)]="filterList.FromSubstitutionDate" (dateChange)="keepFilter();validateSubstitutionDateFilter('fromSubstitutionDate', $event);">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Substitution Date'">
                <div class="text-center deliveryDatePicker">
                  <mat-form-field>
                    <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="To" [matDatepickerFilter]="toSubstitutionDateFilter"
                           readonly [(ngModel)]="filterList.ToSubstitutionDate" (dateChange)="keepFilter();validateSubstitutionDateFilter('toSubstitutionDate', $event);">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-5 col-md-3 col-lg-2 search-btn-outer text-right padding-l20 padding-r0">
        <div class="row">
          <div class="col-sm-6 padding-r15">
            <div class="search-btn">
              <button mat-raised-button class="btns" color="primary" (click)="getFilterData()">Search</button>
            </div>
          </div>
          <div class="col-sm-6 padding-r15">
            <div class="search-btn">
              <button mat-raised-button class="btns" color="primary" [disabled]="bodyDS.length <= 0" (click)="onExportBtnClick()">Export</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="chips-sec">
          <div class="row selected-chip">
            <div class="col-sm-9 col-md-10 padding-l0">
              <div>
                <mat-chip-set>
                  <mat-chip selected *ngFor="let filterValue of filterValueList">
                    {{filterValue}}
                    <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                      <i class="fas fa-times text-right"></i>
                    </a>
                  </mat-chip>
                </mat-chip-set>
              </div>
            </div>
            <div class="col-sm-3 col-md-2 text-right padding-r0" *ngIf="filterValueList.length > 0">
              <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 padding-l30 padding-r0 padding-b10 padding-t10">
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <div class="row">
              <div class="col-md-9 padding-r30 padding-l0 text-left">
                <div class="row">
                  <div class="col-sm-3 col-md-3 padding-r30 padding-t5">
                    <p *ngIf="currentFilter.filterDescription">REPORT NAME: {{currentFilter.filterDescription}}</p>
                  </div>
                  <div class="col-sm-3 col-md-3 padding-r30 padding-t5">
                    <p *ngIf="currentFilter.filterDescription">
                      LAST RUN DATE: {{(currentFilter.lastRunByTimeStamp || currentFilter.createTimeStamp) | date: 'MM/dd/yyyy'}}
                    </p>
                  </div>
                  <div class="col-sm-3 col-md-3 padding-r30">
                    <button mat-raised-button class="btns margin-r10" color="primary" (click)="editFilter()" *ngIf="(currentFilter.userReportFilterId || !(currentFilter.userReportFilterId)) && currentFilter.filterDescription">Edit Report</button>
                    <button mat-raised-button class="btns margin-r10" color="primary" (click)="save()" *ngIf="currentFilter.filterDescription">Save</button>
                  </div>
                </div>
              </div>
              <div class="col-sm-3 col-md-3 text-right">
                <div class="padding-r0 ">
                  <button mat-raised-button class="btns" color="primary" (click)="addFilter()">Create Report</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--HTML table Structure -->

    <div class="row">
      <div class="col-md-12 orderSearchTable">
        <div class="tableTopSec">
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 text-right">
              <mat-paginator [length]="length"
                             [pageSize]="pageSize"
                             [pageSizeOptions]="pageSizeOptions"
                             (page)="onPaginatorChange($event)">
              </mat-paginator>
            </div>
          </div>
        </div>
        <div class="tableContainer ">
          <div class="tableComponentOuter">
            <table class="matTables tableComponentInner mat-table" matSort (matSortChange)="sortData($event)">
              <thead>
                <tr class="mat-header-row">
                  <th [class]="header?.className" *ngFor="let header of headerDS" [mat-sort-header]="header?.columnfield">
                    <div>
                      {{header.headertxt}}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody *ngIf="paginatorDS.length != 0">
                <tr class="mat-row" *ngFor="let row of paginatorDS">
                  <td class="mat-cell" *ngFor="let col of headerDS" [class]="col?.tdClassName">
                    <div [ngSwitch]="col.columnfield">
                      <div *ngSwitchCase="'dealerOrderNumber'" (click)="redirectToOrder($event,row)">
                        <span [ngClass]="{'handCursor' : row.clickable,'text-decoration-underline' : row.clickable}">{{row.dealerOrderNumber}}</span>
                        <span *ngIf="row.b2B" class="erp-order"><i title="B2B" class="fas fa-lock"></i></span>
                      </div>
                      <div *ngSwitchCase="'accountNumber'">
                        {{row.accountNumber}}
                      </div>
                      <div *ngSwitchCase="'accountName'">
                        {{row.accountName}}
                      </div>
                      <div *ngSwitchCase="'city'">
                        {{row.city}}
                      </div>
                      <div *ngSwitchCase="'state'">
                        {{row.state}}
                      </div>

                      <div *ngSwitchCase="'fromProductNumber'">
                        {{row.fromProductNumber}}
                      </div>
                      <div *ngSwitchCase="'fromProductName'">
                        {{row.fromProductName}}
                      </div>
                      <div *ngSwitchCase="'fromTreatment'">
                        {{row.fromTreatment}}
                      </div>
                      <div *ngSwitchCase="'fromSeedSize'">
                        {{row.fromSeedSize}}
                      </div>
                      <div *ngSwitchCase="'fromPackageSize'">
                        {{row.fromPackageSize}}
                      </div>
                      <div *ngSwitchCase="'fromQtyCancelled'">
                        {{row.fromQtyCancelled | number}}
                      </div>

                      <div *ngSwitchCase="'toProductNumber'">
                        {{row.toProductNumber}}
                      </div>
                      <div *ngSwitchCase="'toProductName'">
                        {{row.toProductName}}
                      </div>
                      <div *ngSwitchCase="'toTreatment'">
                        {{row.toTreatment}}
                      </div>
                      <div *ngSwitchCase="'toSeedSize'">
                        {{row.toSeedSize}}
                      </div>
                      <div *ngSwitchCase="'toPackageSize'">
                        {{row.toPackageSize}}
                      </div>
                      <div *ngSwitchCase="'toQtyTransfered'">
                        {{row.toQtyTransfered | number}}
                      </div>

                      <div *ngSwitchCase="'remainingProductNumber'">
                        {{row.remainingProductNumber}}
                      </div>
                      <div *ngSwitchCase="'remainingProductName'">
                        {{row.remainingProductName}}
                      </div>
                      <div *ngSwitchCase="'remainingTreatment'">
                        {{row.remainingTreatment}}
                      </div>
                      <div *ngSwitchCase="'remainingSeedSize'">
                        {{row.remainingSeedSize}}
                      </div>
                      <div *ngSwitchCase="'remainingPackageSize'">
                        {{row.remainingPackageSize}}
                      </div>
                      <div *ngSwitchCase="'remainingQtyTransfered'">
                        {{row.remainingQtyTransfered | number}}
                      </div>

                      <div *ngSwitchCase="'substitutionDate'">
                        {{ row?.substitutionDate | date:'MM/dd/yyyy'}}
                      </div>

                      <div *ngSwitchDefault>
                        {{row[col?.columnfield]}}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody *ngIf="paginatorDS.length == 0">
                <tr>
                  <td class="mat-cell" colspan="9" valign="middle">
                    <div class="noRecordMsg">
                      No record Found.
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
